import { useI18n, type Composer } from 'vue-i18n'

const translations = {
  'pt-br': {
    Accountings: 'Contabilidade',
    AccountPlans: 'Plano de contas',
    AccountsPayables: 'Contas a pagar',
    AccountsReceivables: 'Contas a receber',
    AddCashier: 'Cadastrar Caixas',
    AllCustomers: 'Todos os clientes',

    Applications: 'Aplicações',
    AppsAndExtraModules: 'Apps & Módulos Extras',
    AppsMonitor: 'Monitor de Applicativos',
    BankAccounts: 'Contas bancárias',
    BankReconciliation: 'Conciliação bancária',
    BankSlips: 'Boletos',
    Benefits: 'Benefícios',
    Bi: 'Acesso BI',
    Bills: 'Faturas',
    BrandAndPersonalization: 'Personalização & Marca',
    Campaigns: 'Campanhas',
    CardContracts: 'Contrato de cartões e outros',
    Carriers: 'Transportadoras',
    CashierManagement: 'Gerenciar caixas',
    CashFlow: 'Fluxo de caixa',
    CashMovements: 'Fechamento de caixa',
    Catalog: 'Catálogo',
    Categories: 'Categorias',
    Changes: 'Troca',
    Companies: 'Empresas',
    CompaniesInfo: 'Dados das filiais',
    Completions: 'Finalizações',
    Confirm: 'Confirmar',
    Consigned: 'Consignado',
    CostCenter: 'Centro de custo',
    CostCenterAnalysis: 'Análise de centro de custo',
    Customers: 'Clientes',
    CustomersCredit: 'Crédito de clientes',
    DeliveryAreas: 'Áreas de entrega',
    DigitalCertificates: 'Certificados digitais',
    EntryInvoices: 'NFe de entrada',
    ExchangeAndReturn: 'Trocas & Devoluções',
    Expenses: 'Despesas',
    FeedbackFormTitle: 'Ajude-nos a melhorar! Qual o motivo da sua volta?',
    Finance: 'Finanças',
    Financial: 'Financeiro',
    FinancialGroups: 'Grupos Financeiros',
    FinancialOrganization: 'Organização financeira',
    Fiscal: 'Fiscal',
    FiscalSettings: 'Configurações fiscais',
    FulfillmentModes: 'Modos de Entrega',
    General: 'Geral',
    GeneralSettings: 'Configurações gerais',
    Integrations: 'Integrações',
    Invoice: 'Nota Fiscal',
    Logistics: 'Logística',
    ManageStock: 'Controle de estoque',
    Management: 'Gestão',
    Marketing: 'Marketing e Divulgação',
    MovementsCategory: 'Categorias de Movimentação',
    MyReports: 'Meus Relatórios',
    MyPlan: 'Meu plano',
    NewMovement: 'Registrar movimentação',
    Nfe: 'Facilita NFe',
    OnlineStore: 'Loja online',
    OrderingModes: 'Modos de pedidos',
    Others: 'Outros',
    OutboundInvoices: 'Notas fiscais',
    Overview: 'Visão geral',
    PaymentForms: 'Métodos de Pagamentos',
    PaymentMethods: 'Métodos de pagamento',
    PointOfSale: 'Ponto de venda',
    PointOfSaleSettings: 'Configurações do PDV',
    PreviousVersion: 'Versão anterior',
    Production: 'Produção',
    ProductionOrders: 'Pedidos de produção',
    ProductionProcess: 'Processo de produção',
    Products: 'Produtos',
    Profits: 'Lucros',
    Proposals: 'Propostas',
    Promotions: 'Promoções',
    Purchases: 'Compras',
    PurchaseOrders: 'Pedidos de compra',
    ReceiptsAndPrintedNotes: 'Recibos e Notas Impressas',
    Reports: 'Relatórios',
    ReportsBasic: 'Relatórios Básicos',
    ReportsSelfService: 'Relatórios Dinâmicos',
    Reservations: 'Reservas',
    ReservationAgenda: 'Agenda',
    ReservationSpaces: 'Espaços',
    ReservationCategories: 'Categorias',
    Results: 'Resultados',
    Sales: 'Vendas',
    SalesAbandonments: 'Abandono de Vendas',
    SalesChannel: 'Canais de venda',
    SalesContacts: 'Contatos de vendas',
    SalesOrders: 'Pedidos de venda',
    Security: 'Segurança',
    ServiceAtStore: 'Atendimento no local',
    ServiceOrder: 'Ordem de serviço',
    Settings: 'Configurações',
    Statements: 'Extratos',
    Stock: 'Estoque',
    StockManagement: 'Gestão de estoque',
    Store: 'Loja Online',
    StoreConfiguration: 'Configuração',
    StoreCustomization: 'Personalização',
    StoreInfo: 'Informações da loja',
    StorePayments: 'Pagamentos',
    Supplier: 'Fornecedores',
    System: 'Sistema',
    SystemPreferences: 'Preferências do sistema',
    SystemUsers: 'Usuários do sistema',
    Tabs: 'Comandas',
    TabsSerires: 'Séries de comandas',
    Tables: 'Mesas',
    TablesAndTabs: 'Mesas e Comandas',
    TableServices: 'Serviços de mesa',
    TaxSettings: 'Parâmetros fiscais',
    TeamsAndPermission: 'Equipes & Permissões',
    TerminalAndDevices: 'Terminais & Dispositivos',
    Tickets: 'Chamados',
    Transactions: 'Movimentações',
    Transfer: 'Transferências',
    UnitOfMeasurement: 'Unidades de medida',
    UserLogs: 'Logs de usuário',
    VariantsAndOptions: 'Variações e opções',
    SATStatus: 'Status SAT'
  },
  'en-US': {}
}

export const useTranslation = (): Composer<typeof translations> => {
  const i18n = useI18n()

  try {
    for (const [key, values] of Object.entries(translations)) {
      i18n.mergeLocaleMessage(key, values)
    }
  } catch (e) {
    /* empty */
  }

  return useI18n({ messages: translations })
}
